<template>
  <BModal
    :model-value="modal"
    scrollable
    centered
    title="Cleaning"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Cleaning</h5>
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BForm>
      <div class="form-group">
        <select name="" id="" class="form-select">
          <option value="">Select Type Room</option>
          <option
            value=""
            v-for="(type_room, index) in type_rooms"
            :key="index"
          >
            {{ type_room }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <select name="" id="" class="form-select">
          <option value="">Select Housekeeping</option>
          <option
            value=""
            v-for="(housekeeping, index) in housekeepers"
            :key="index"
          >
            {{ housekeeping }}
          </option>
        </select>
      </div>
      <BRow>
        <BCol>
          <div class="form-group">
            <label for="">Set Start Date</label>
            <BFormInput type="date"> </BFormInput>
          </div>
        </BCol>
        <BCol>
          <div class="form-group">
            <label for="">Set End Time</label>
            <BFormInput type="time"> </BFormInput>
          </div>
        </BCol>
      </BRow>
      <div class="form-group">
        <BFormTextarea placeholder="Remarks"></BFormTextarea>
      </div>
    </BForm>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="primary" @click="submitReservation" class="mr-2"
          >Save</BButton
        >
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
  </BModal>
</template>

<script>
import { ref } from "vue";
import {
  BRow,
  BCol,
  BModal,
  BFormTextarea,
  BFormInput,
  BButton,
} from "bootstrap-vue-next";

export default {
  name: "CleaningForm",
  components: {
    BRow,
    BCol,
    BModal,
    BFormTextarea,
    BFormInput,
    BButton,
  },
  props: {
    modal: Boolean,
  },
  setup(props, { emit }) {
    console.log(props);

    const housekeepers = ref(["Budi", "Andi", "Siti", "Mamat", "Rina"]);
    const type_rooms = ref([
      "Deluxe",
      "Super Deluxe",
      "Honeymoon",
      "Family",
      "Studio",
    ]);
    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };
    return {
      updateModal,
      housekeepers,
      type_rooms,
    };
  },
};
</script>

<style></style>
